import * as is from 'is';

/**
 * Constrains the number argument to a minimum and/or maximum value.
 * 
 * @param {number} number The number whose value is to be restricted.
 * @param {object} [options] The contains the for contricting the number's value.
 * @param {number} [options.minimum = MIN_SAFE_INTEGER] The lower bound, inclusive, that the number's value may be.
 * @param {number} [options.maximum = MAX_SAFE_INTEGER] The upper bound, inclusive, that the number's value may be.
 * @throws {TypeError} If something other than a number is provided for the first argument, or the options properties.
 * @returns {number}
 */
export function clamp(number, options = {}) {
  const {
    minimum = Number.MIN_SAFE_INTEGER,
    maximum = Number.MAX_SAFE_INTEGER,
  } = options || {};
  if (!is.number(number)) {
    throw new TypeError('number must be a number');
  }
  if (!is.number(minimum)) {
    throw new TypeError('minimum must be a number');
  }
  if (!is.number(maximum)) {
    throw new TypeError('maximum must be a number');
  }
  return Math.max(Math.min(number, maximum), minimum);
}
